export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.log('Service Workers are not supported in this browser');
    return;
  }

  try {
    // Dynamic import to handle virtual module properly
    const { registerSW } = await import('virtual:pwa-register');

    // Register the service worker with update callback
    const updateSW = registerSW({
      onNeedRefresh() {
        // Show a notification when update is available
        showUpdateNotification(() => {
          updateSW();
          window.location.reload();
        });
      },
      onOfflineReady() {
        console.log('App is ready for offline use');
      },
    });

    console.log('Service Worker registered successfully');
  } catch (error) {
    console.error('Service Worker registration failed:', error);
  }
}

/**
 * Show an update notification to the user
 * This creates a simple banner at the top of the page
 */
function showUpdateNotification(onUpdate: () => void) {
  // Remove any existing notification
  const existingNotification = document.getElementById('pwa-update-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  // Create notification element
  const notification = document.createElement('div');
  notification.id = 'pwa-update-notification';
  notification.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 16px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 9999;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
    ">
      <div style="display: flex; align-items: center; gap: 12px; flex: 1;">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style="flex-shrink: 0;">
          <path d="M10 2C5.58 2 2 5.58 2 10s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm-2 12l-4-4 1.41-1.41L8 11.17l6.59-6.59L16 4.99 8 13z" fill="currentColor"/>
        </svg>
        <span style="font-weight: 500;">Update available! A new version of HAI Reporting Tool is ready.</span>
      </div>
      <div style="display: flex; gap: 12px; flex-shrink: 0;">
        <button id="pwa-update-dismiss" style="
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: white;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s;
        " onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'" onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'">
          Later
        </button>
        <button id="pwa-update-button" style="
          background: rgba(255, 255, 255, 0.9);
          color: #667eea;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.2s;
        " onmouseover="this.style.background='white'" onmouseout="this.style.background='rgba(255, 255, 255, 0.9)'">
          Update Now
        </button>
      </div>
    </div>
  `;

  document.body.insertBefore(notification, document.body.firstChild);

  // Handle buttons
  const updateButton = document.getElementById('pwa-update-button');
  const dismissButton = document.getElementById('pwa-update-dismiss');

  if (updateButton) {
    updateButton.addEventListener('click', () => {
      onUpdate();
      notification.remove();
    });
  }

  if (dismissButton) {
    dismissButton.addEventListener('click', () => {
      notification.remove();
    });
  }
}

/**
 * Force refresh the service worker immediately
 * Useful for manual updates
 */
export async function forceUpdateServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.update();
        console.log('Service Worker update check completed');
      }
    } catch (error) {
      console.error('Failed to update service worker:', error);
    }
  }
}

/**
 * Unregister all service workers
 * Use only if you need to disable PWA functionality
 */
export async function unregisterServiceWorkers() {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
      }
      console.log('All service workers unregistered');
    } catch (error) {
      console.error('Failed to unregister service workers:', error);
    }
  }
}
